import { useCallback, useState } from 'react';
import { IMessageInfo, IMultiSuggestResult } from '@cian/geosuggest-widget';
import { path } from 'ramda';
import { debounce } from 'throttle-debounce';
import { useDispatch } from 'react-redux';

import { EAddressType, getYandexSuggest } from '../../../actions/geoSuggest/getYandexSuggest';
import { TThunkDispatch } from '../../../types/redux';

export const NOT_FOUND_ERROR: IMessageInfo = {
  title: 'Ничего не найдено',
  text: 'Укажите другой адрес',
};

export const useGeoSuggest = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const [isFetching, setIsFetching] = useState(false);
  const [suggestError, setSuggestError] = useState<IMessageInfo>();
  const [suggestData, setSuggestData] = useState<IMultiSuggestResult>();

  const getSuggestions = useCallback(
    async (addressChunk: string) => {
      setIsFetching(true);
      setSuggestError(undefined);

      const suggestResult: IMultiSuggestResult = await dispatch(
        getYandexSuggest({
          request: addressChunk.trim(),
          addressType: EAddressType.house,
        }),
      );

      setIsFetching(false);

      const suggestLength = path(['suggestions', 'addresses', 'length'], suggestResult);
      if (suggestLength) {
        return setSuggestData(suggestResult);
      }

      setSuggestError(NOT_FOUND_ERROR);
      setSuggestData(undefined);
    },
    [dispatch],
  );

  // oxlint-disable-next-line react/exhaustive-deps
  const getGeoSuggestDebounced = useCallback(debounce(200, getSuggestions), [getSuggestions]);

  return {
    isFetching,
    suggestError,
    suggestData,
    getSuggestions: getGeoSuggestDebounced,
  };
};
